import React, { useEffect } from "react";
import Loader from "../../../../Loader/Lodaer";

export interface AuthProp {
    typeAuth: string
}

export default function SuccessAuth({typeAuth}: AuthProp) {
    const AuthChanel = new BroadcastChannel('Auth') 
    const receivedUrl = new URL(window.location.href)

    useEffect(() => {
        if (receivedUrl.searchParams.get('code')) {
            let code = receivedUrl.searchParams.get('code')
            let deviceId = receivedUrl.searchParams.get('device_id') ?? null
            AuthChanel.postMessage({type: typeAuth, payload: {code: code, deviceId: deviceId}})
            setTimeout(() => {
                window.close()
            }, 450);
        }
         /* eslint-disable-next-line react-hooks/exhaustive-deps */
    }, [])
    
    return ( 
        <Loader />
    )
}